import { z } from 'zod';

export const themeConfigSchema = z.object({
  palette: z.object({
    primary: z.object({
      main: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
    }),
    secondary: z.object({
      main: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
    }),
    type: z.enum(['light', 'dark']).default('dark'),
  }),
});

type ThemeSchemaType = z.infer<typeof themeConfigSchema>;

const defaultValue: ThemeSchemaType = {
  palette: {
    primary: { main: '#F59E18' },
    secondary: { main: '#F44336' },
    type: 'dark',
  },
};

export const themeDefaultValue = JSON.stringify(defaultValue, null, '\t');
